export default {
  'new': 'New Appointment',

  'overlapping': 'Overlapping services',
  'note-for-client': 'Note for client (optional)',
  'reason-for-cancelling': 'Enter the reason for cancelling or suggest another date.',

  'date': 'Date',
  'start': 'Start',
  'end': 'End',
  'service': 'Service',
  'select-service': 'Select service',

  'add-service': 'Add another service',
  'bgc-info-tip': 'How can I complete checkout with a Booksy Gift Card?',

  'total': 'Total',
  'appointment-price': 'Appointment price',
  'due-for-group-booking': 'Due for group booking',
  'to-be-paid': 'To be paid',

  'wait-time': 'Waiting time – {time}',
  'wait-time-gap': 'Processing break ({time})',
  'wait-time-gap-hole': 'Processing time – {time} [during the service]',
  'wait-time-gap-included': 'Waiting time {wtime}, including {gtime} processing time',
  'wait-time-gap-error': 'Waiting time shorter than processing time',

  'staffer': 'Staffer',
  'staff': 'Staff',
  'any-staffer': 'Any staffer',
  'select-staffer': 'Select a Staff Member',
  'staffer-not-required': 'No staffer required',
  'no-staffer': 'No staffer',

  'resource': 'Resource',
  'any-resource': 'Any resource',
  'select-resource': 'Select resource',
  'resource-not-required': 'No resource required',
  'no-resource': 'No resource',

  'booking-type-c': 'Client Booking ID: {id}',
  'booking-type-b': 'Business Booking ID: {id}',
  'time-reservation-id': 'Time Reservation ID: {id}',

  'services-perfomed-by': 'Services performed by {staffer}',
  'service-not-performed': 'Service not performed by this Staffer',
  'appliance-not-performed': 'Service not available for selected Resource',
  'search-service': 'Search services...',
  'select-from-list': 'Select from list or search...',
  'add-custom-service': 'Add "{servicename}" as a one time service',

  'staffer-available': 'Staff Member',
  'resource-available': 'Resource available from',
  'available-from': 'Available from {date}',

  'not-signed': 'Not signed',

  'staffer-not-active': 'Staffer is no longer active',
  'resource-not-active': 'Resource is no longer active',

  'staffer-not-performing': 'Doesn\'t offer this service',
  'resource-not-performing': 'Resource doesn\'t perform it',

  'conflicts-with-calendar': 'Conflicts with calendar',

  'internal-note': 'Internal Note (staff visible only)',
  'message-from-client': 'Message from client',
  'message-for-client': 'Message for client',
  'visit': 'Visit',

  'client-no-show': 'Client No-Show',
  'appointment-cancellation': 'Appointment Cancellation',
  'appointment-cancellation-desc': 'Enter a reason for cancelling or suggest another date, so client will be notified',

  'cancel-appointments-text': 'You\'re about to cancel your appointment on {date}. This appointment is part of a set of recurring appointments:',
  'cancel-only-this': 'Cancel only this appointment',
  'cancel-all': 'Cancel this and future appointments',

  'cancel-group-booking': 'Cancel Group Booking?',
  'cancel-group-booking-text': 'You are about to cancel an appointment on',
  'cancel-group-booking-text-2': 'This appointment is part of a group booking ({count} person). Would you like to cancel only this appointment or all appointments in the group booking? | This appointment is part of a group booking ({count} people). Would you like to cancel only this appointment or all appointments in the group booking?',
  'cancel-this': 'Cancel this appointment',
  'cancel-all-in-group': 'Cancel all appointments',

  'appointments-update': 'Appointments Update',
  'appointments-update-text': 'You\'re about to make changes to your appointment on {date}. This appointment is part of a set of recurring appointments:',
  'appointments-update-text-2': 'Would you like to apply the changes to future appointments in the recurring series?',
  'update-only-this': 'Update only this appointment',
  'update-all': 'Update this and future appointments',

  'reschedule-group-booking': 'Reschedule Group Booking?',
  'reschedule-group-booking-text': 'You are about to reschedule an appointment on',
  'reschedule-group-booking-text-2': 'This appointment is part of a group booking ({count} person). Would you like to reschedule only this appointment or all appointments in the group booking? | This appointment is part of a group booking ({count} people). Would you like to reschedule only this appointment or all appointments in the group booking?',
  'reschedule-this': 'Reschedule this appointment',
  'reschedule-all-in-group': 'Reschedule all appointments',

  'confirm-modification': 'Modify existing appointment?',
  'confirm-modification-reservation': 'Would you like to modify your existing uavailability?',
  'discard-changes': 'Discard changes to this appointment',
  'discard-changes-reservation': 'Discard changes to this uavailability',
  'discard-new-appointment': 'Discard New Appointment?',
  'discard-new-time-reservation': 'Discard Time Reservation?',
  'discard-changes-desc': 'This action cannot be undone.',
  'discard-changes-button': 'Discard',
  'notify-client': 'Notify client about changes?',

  'no-go-back-appointment': 'No, go back',
  'no-go-back-reservation': 'No, go back',

  'time-reservation': 'Time Reservation',
  'add-time-reservation': 'Add Time Reservation',
  'edit-time-reservation': 'Edit Time Reservation',
  'remove-time-reservation': 'Remove Time Reservation',
  'cancel-time-reservation': 'Time Reservation Cancellation',
  'reason': 'Reason',

  'day-off': 'Day Off',

  'overbooking-heading': 'Schedule Conflict',
  'overbooking-description': 'This appointment conflicts with another appointment. Continue?',
  'overbooking-repeating-appointments-on': 'For appointments on:',
  'overbooking-repeating-description': 'These appointments conflict with something on the calendar.',
  'overbooking-repeating-description-2': 'Continuing to book this appointment may create overlaps with existing appointments, time off or hours of operation. ',
  'overbooking-group-heading': 'Booking Conflicts',
  'overbooking-group-booking-on': 'You are about to make a group booking on',
  'overbooking-group-description': 'Continuing to book these appointments may create conflicts in calendar or availability issues. Some appointments will need to be updated individually to resolve conflicts.',

  'confirm-client-no-show': 'Confirm No-Show',
  'charge-cancellation-fee': 'Charge Cancellation Fee {fee_value}',
  'waive-cancellation-fee': 'Waive Cancellation Fee {fee_value}',

  'release-deposit-header': 'Waive cancellation fee',
  'release-deposit-description': 'Waive cancellation fee for {price} ?',
  'keep-cancellation-fee-cta': 'Keep cancellation fee!',
  'waive-cancellation-fee-cta': 'Waive cancellation fee',

  'new-client': 'New client?',
  'new-client-description': 'Add client details so that you can send appointment reminders and encourage them to book with you again.',
  'add-client-details': 'Add client details',
  'cancel-add-client-details': 'I don\'t want to build clientele',
  'not-now': 'Not Now',
  'select-a-client': 'Select a client or leave empty for walk-in',
  'walk-in': 'Walk-in',

  'add-client-modal': {
    'title': 'Add Phone Number or E-Mail',
    'description': 'Why should you get the clients phone number or e-mail?<br><br>• So the client can receive appointment notifications<br>• So you can contact them in the future<br>• So you can protect your bottom line with No-Show Protection',
  },

  'custom-forms': {
    'walkin-modal': {
      'title': 'Custom Form Required',
      'desc': 'This client has not signed the required form(s) yet. Please create their client card so that you can add the correct documentation.',
      'button': 'Create client card',
      'cancel': 'Continue without form',

    },
  },

  'appointment-tab': 'Appointment',
  'notes-info-tab': 'Notes & Info',
  'traveling-tab': 'Mobile Services',
  'online-services-tab': 'Online Services',

  'date-week': '{count} appointment | {count} appointments',

  'change-staffer': 'Assign this Staffer?',
  'change-resource': 'Assign this Resource?',
  'change-staffer-description': 'This appointment includes a Service that is not typically assigned to this Staffer. Are you sure you would like to continue?',
  'change-resource-description': 'This appointment includes a Service that is not typically assigned to this Resource. Are you sure you would like to continue?',

  'drag-multibooking': 'Oops! This appointment is multibooking. The action is not available.',
  'error-combo-drag-drop': 'You can’t drag and drop combo services',

  'no-appointments': 'No upcoming appointments',

  'starred': 'Starred',
  'selected-manually': 'Staff Member chosen manually',
  'assigned-by-turn-tracker': 'Assigned by Turn Tracker',
  'assigned-by-system': 'Assigned by system',
  'staff-assigned-automatically': 'Staff members assigned automatically (group booking)',
  'appliance-assigned-automatically': 'Resources assigned automatically (group booking)',

  'requested-by-client': 'Requested by client',
  'requested-by-client-hint': 'Check if the Staff Member has been assigned based on the Client’s preference to find out whether you can assign the Appointment to someone else.',

  'charge-cancellation-fee-button': 'Charge Cancellation Fee',

  'traveling': {
    'header': 'Mobile Services',
    'show-on-map': 'Show on map',
    'address': 'Address',
    'street': 'Street',
    'travel-fee': 'Travel fee',
    'not-set': 'Not set',
    'turned-off': 'Mobile Services Turned Off',
    'optional': 'Mobile Services',
    'street-address': 'Street address & number',
    'apartment-number': 'Suite number (optional)',
    'city': 'City',
    'zip-code': 'Zip code',
    'are-u-sure': 'Are you sure?',
    'are-u-sure-desc': 'The client address will be permanently removed form the appointment.',
    'clear-address': 'Clear address',
    'add-street': 'Add "{street}" as a street',
    'search-placeholder': 'Search street & number',
    'fee-is-required': 'Travel fee is required',
    'address-is-required': 'Mobile Service destination address is required',
    'min-value': 'Value should be greater than 0',
  },

  'boost-badge': 'Boost Client: 1st Visit',

  'change-status': 'Change',
  'select-client': 'Select Client',
  'reserved-by': 'Reserved by',
  'reserved-by-source': 'Reserved by {source}',
  'reserved-via': 'Reserved via {source}',
  'reserved-with': 'Reserved with {source}',
  'ready': {
    'header': 'Are you ready?',
    'content': 'If so we\'ll let your client know that they\'re free to come in for their appointment.',
  },

  'online-services-title': 'Online Services',
  'online-services-description': 'Provide remote services, online consultations and tutorials. Click the button below to launch Zoom and start a meeting.',
  'online-services-cta': 'Start Meeting',

  'service-select': {
    'performed-by': 'Performed by',
    'all-services': 'All services',
  },

  'multibooking-edit': {
    'title': 'Service',
  },

  'addons': {
    'include-addons': '(incl. Add-ons)',
    'title': 'Add-ons',
    'select-an-addon': 'Select an Add-on',
    'placeholder': 'Type add-on name',
    'assigned-to-service': 'Assigned to this service',
    'all-addons': 'All Add-ons',
    'qty': 'Qty',
    'no-selected': 'No add-ons selected',
    'no-assigned': 'No add-ons assigned to this service',
  },

  'redo-modal': {
    title: 'Redo last booked appointment?',
    'manually': 'Choose service manually',
    'with': 'with {staffer}',
  },

  'combo': {
    'title': 'Edit Combo Service',
    'label': 'Combo',
    'conflicts': 'There are availablity issues. Please update the appointment details.',
    'description': {
      'parallel': 'Parallel Combo · {count} services',
      'sequence': 'Sequence Combo · {count} services',
    },
    'any-staffer-confilct': {
      'title': 'Availability issues',
      'description': 'The staff member or resource you have selected are not available. Please update the appointment details to continue.',
      'fix-conflicts': 'Update appointment details',
    },
    'multibooking-modal': {
      'title': 'Unable to add a combo service',
      'description': 'Currently, it’s not possible to add a combo service to an appointment with multiple services. Please select a different service.',
      'got-it': 'OK, got it',
    },
    'edit-conflict-modal': {
      title: 'This change will effect other services',
      text: 'The service you selected is part of a Combo Service. If you change this service will change the Combo Service as well.',
      confirm: 'Apply changes',
    },
  },
  'patient': 'Patient',
  'med': 'Med',
  'patient-card': 'Patient\'s card',
  'patient-card-warning': 'Incomplete patient\'s card',
  'start-examination': 'Start examination',
  'fill-patient-card': 'Fill in patient\'s card',
  'go-to-patient-card': 'Go to patient\'s card',
  'save-appointment-and-go-to-patient-card': 'Save appointment and go to patient\'s card',
  'with': 'with {name}',

  appointment: {
    form: {
      'appointment-tab': {
        prepayment: {
          title: 'Deposit required',
          description: 'Client will have 12 hours to pay the required amount. Otherwise, booking will be canceled.',
          'description-not-eligible': 'Not eligible for this appointment',
          infoTip: {
            title: 'Request a deposit',
            subtitle1: 'To request deposit the following requirements must be met.',
            subtitle2: '1. Appointment must be booked at least 24 hours in the future.',
            subtitle3: '2. Client must be a Booksy user.',
            subtitle4: '3. Client must not be marked as a Trusted Client.',
            subtitle5: '4. Deposit must be enabled for the selected service.',
          },
        },
        'keyed-in-payment': {
          'title': 'Collect Deposit with Keyed In Payment',
          'description': 'Manually enter card details to charge the total or a partial amount of a booking.',
        },
        'blik-deposit': {
          'title': 'Collect deposit with BLIK',
          'description': 'Enter the BLIK code provided by the client to collect a deposit for this booking.',
        },
        'payment-tile': {
          'prepayment-requested': 'Deposit requested',
          'prepayment-deadline': 'Deposit deadline: {prepaymentDeadline}',
        },
      },
    },
    'saved-with-prepayment': 'Deposit request sent',
  },

  'boost-appointment-cancellation': {
    'mark-as-no-show-title': 'Mark appointment as no-show?',
    'leave-in-calendar': 'Leave appointment in calendar',
    'mark-as-no-show': 'Mark as no-show',
    'we-have-noticed': 'We have noticed your account has a <b>higher than average number of appointments from Boost marked as no-shows.</b>',
    'large-amount-of-appointments': 'Having a large amount of Boost appointments marked as no-shows on your account may result in the <b>Boost service being temporarily disabled.</b>',
    'are-you-sure': 'Are you sure you want to mark this appointment as no-show?',
    'heads-up': 'Heads up!',
    'boost-helps': 'Boost helps you improve your <b>business visibility on Booksy and promote your service to millions of Booksy users.</b>',
    'boost-can-support': 'Having a large amount of Boost appointments marked as no-shows on your account may affect <b>how well Boost can support you and your business.</b>',
    'important-notice': 'Important notice',
    'we-are-sorry': 'We’re sorry to hear that this client did not attend their appointment. We know your time is valuable so to avoid wasting it, <b>we will not recommend your business to this client again.</b>',
    'cancel-appointment': 'Cancel appointment',
    'cancel-appointment-title': 'Cancel appointment?',
    'we-have-noticed-cancel': 'We have noticed your account has a <b>higher than average number of canceled appointments</b> from Boost.',
    'large-amount-of-cancels': 'Having a large amount of canceled Boost appointments on your account <b>may result in the Boost service being temporarily disabled.</b>',
    'are-you-sure-cancel': 'Are you sure you want to cancel this appointment?',
    'cancels-affect-boost': 'Having a large amount of canceled Boost appointments on your account <b>may affect how well Boost can support you and your business.</b>',
    'sorry-client-canceled': 'We’re sorry to hear that this client canceled their appointment. We know your time is valuable so to avoid wasting it, <b>we will not recommend your business to this client again.</b>',
  },

  /** payments */
  'booking-mode-modal': {
    'apple-pay-google-pay': {
      'title': 'Your clients can\'t make payments with Apple Pay and Google Pay',
      'description': 'Automatic booking confirmation is currently disabled which means your clients can\'t complete deposits with Apple Pay or Google Pay.<br><br>Don\'t limit your earning potential - enable automatic booking confirmation now to allow clients to pay with Apple Pay and Google Pay.',
    },
    'blik': {
      'title': 'Your clients can\'t make payments with BLIK',
      'description': 'Automatic booking confirmation is currently disabled which means your clients can’t complete deposits with BLIK.<br><br>Don’t limit your earning potential – enable automatic booking confirmation now to allow clients to pay with BLIK.',
    },
    'enable-auto-confirm': 'Enable automatic booking confirmation',
    'toast': 'Automatic booking confirmation has been enabled',
  },
  'deposit-payment-modal': {
    'title': 'Collect Deposit',
    'text': 'Collect payment for bookings by manually entering client’s card details. You can charge the full amount of the service now or enter a set amount.',
    'amount': {
      'label': 'Amount',
      'constraint-text': 'Amount cannot be higher than total cost of services - {total}',
      'validation': {
        'maxValue': 'Amount cannot be higher than total cost of services',
        'minValue': 'The amount must not be less than {amount}',
      },
    },
    'processing': {
      'header': 'Processing payment',
    },
    'card-form': {
      'payment-method-label': 'Payment method',
    },
    'payment-success': {
      'header': 'Payment completed',
      'text': 'The amount charged will be deducted from the total price during the checkout process.',
      buttons: {
        'primary-button': 'Go to calendar',
        'secondary-button': 'Done',
      },
    },
    'payment-failure': {
      'header': 'Payment could not be completed',
      'text': 'Please try again',
      buttons: {
        'primary-button': 'Retry payment',
        'secondary-button': 'Confirm booking without Deposit',
      },
    },
    'schedule-conflict': {
      'header': 'Schedule conflict',
      'text': 'This appointment conflicts with another appointment. Continue?',
      buttons: {
        'primary-button': 'Continue',
        'secondary-button': 'Cancel',
      },
    },
    'buttons': {
      'continue': 'Continue',
      'cancel': 'Go back',
    },
    'blik': {
      'title': 'Enter BLIK code',
      'text': 'Enter the BLIK code that the client provided you from their banking app.',
      'info-box': {
        'text': 'Never ask for the code if you\'re the one calling the client—they may view it as a scam attempt. This also violates our Terms of Service. You can find more information in our <a href="https://help.booksy.com" target="_blank" rel="noopener noreferrer" class="b-text-link">Help Center</a>.',
      },
      'code': {
        'label': 'BLIK code',
        'placeholder': 'BLIK code',
        'message': 'Customers can find the BLIK code in their banking app.',
        'validation': {
          'to-short': 'The BLIK code must be 6 digits',
        },
      },
      'processing': {
        'header': 'Ask the client to confirm the payment in their banking app',
      },
      'buttons': {
        'confirm': 'Charge deposit',
        'go-back': 'Go back',
      },
    },
  },
  'premium-hours': 'Premium Hours',
  'refund-modal': {
    'header': 'Issue refund for canceled appointment?',
    'text': 'This appointment has been prepaid with Booksy Pay. Please confirm you want to issue a full refund to the client. A refund fee of {fee} applies.',
    'buttons': {
      'refund': 'Refund payment',
      'not-now': 'Not now',
    },
    'success-info': 'Refund has been issued',
  },
}
